<div>
    <ion-icon name="fas-calendar" aria-hidden="true" />
    <strong>{{ label }}</strong> {{ readableTime }}
</div>

<core-reminders-set-button *ngIf="showReminderButton" slot="end" [component]="component" [instanceId]="instanceId" [type]="type"
    [label]="label" [initialTimebefore]="timebefore" [time]="time" [title]="title" [url]="url" />
